import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';
import { OrgPersLokVyer } from './OrgPersLok/OrgPersLok';

export const OPVyer = initConst<IComponentsConfig>(() => ({
  OPOrgPersLok: OrgPersLokVyer,
}));
